import { Button, Card, Form, Input, Select } from "antd";
import PhoneInput from "antd-phone-input";
import { useLoader } from "../../Context/LoaderContext";
import { EnquiryDto } from "../../Dto/Enquiry.dto";
import enquiryService from "../../Service/enquiry.service";
import { openNotification } from "../../Components/Notification";
import { useNavigate } from "react-router-dom";

const companySizeOptions = [
  { label: "1-10", value: "1-10" },
  { label: "10-50", value: "10-50" },
  { label: "50-100", value: "50-100" },
  { label: "More than 100", value: "More than 100" },
];

const EnterprisePlanContactForm = () => {
  const { isLoading, setLoading } = useLoader();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const onFinish = async (values: any) => {
    try {
      setLoading(true);
      const payload: EnquiryDto = {
        name: values.name,
        position: values.position,
        companySize: values.companySize,
        phoneNumber: `+${values.phoneNumber.countryCode}${values.phoneNumber.areaCode || ""}${values.phoneNumber.phoneNumber}`,
      };
      const response = await enquiryService.sendEnquiry(payload);
      if (response) {
        form.resetFields();
        navigate("/");
      } 
    } catch (error) {
      console.log("ERROR", error);
    } finally {
      setLoading(false);
    }
  };
  const validator = (_: any, value: any) => {
    // If no value yet, let the required rule handle it
    if (!value) return Promise.resolve();
    // Check if valid function exists and call it
    if (value.valid && value.valid(true)) return Promise.resolve();
    return Promise.reject("Invalid phone number");
  };
  return (
    <div className="enterprise-plan-contact-form">
      <Card>
        <Form
          form={form}
          layout="vertical"
          autoComplete="off"
          onFinish={onFinish}
        >
          <Form.Item
            label="Name"
            name="name"
            rules={[
              { required: true, message: "Please enter your name" },
              {
                pattern: /^[A-Za-z\s]{2,50}$/,
                message:
                  "Name must contain only letters and be 2-50 characters long!",
              },
            ]}
          >
            <Input placeholder="Eg. John Doe" />
          </Form.Item>
          <Form.Item
            label="Position"
            name="position"
            rules={[
              { required: true, message: "Please enter your position" },
              {
                pattern: /^[A-Za-z\s]{2,50}$/,
                message:
                  "Position must contain only letters and be 2-50 characters long!",
              },
            ]}
          >
            <Input placeholder="Eg. Manager, CEO" />
          </Form.Item>
          <Form.Item
            label="Phone Number"
            name="phoneNumber"
            rules={[
              { required: true, message: "Please enter your phone number" },
              { validator },
            ]}
          >
            {/* <Input placeholder="Enter your phone number" /> */}
            <PhoneInput
              placeholder="Enter your phone number"
              enableSearch
              disableParentheses
              country="in"
            />
          </Form.Item>
          <Form.Item
            label="Company Size"
            name="companySize"
            rules={[
              { required: true, message: "Please select a company size" },
            ]}
          >
            <Select
              placeholder="Select company size"
              options={companySizeOptions}
              allowClear
            />
          </Form.Item>
          <Button type="primary" htmlType="submit" block loading={isLoading}>
            Submit
          </Button>
        </Form>
      </Card>
    </div>
  );
};

export default EnterprisePlanContactForm;
